import DonutChart from "../../../components/Charts/DonutChart";
import { useEffect, useState } from "react";
import { axInstBasic } from "../../../components/Service/Service";

export default function VehicleInsuranceExpiring({ isArn }) {
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!isArn) return; // Don’t call API until ARN is available

      try {
        const response = await axInstBasic.post(
          `${process.env.REACT_APP_API_URL}PermitType`,
          { isArn }
        );

        const rawResponse = response.data;

        const aggregatedData = Array.isArray(rawResponse.result?.buckets)
          ? rawResponse.result.buckets.map((bucket) => ({
              name: bucket.key,
              value: bucket.doc_count,
            }))
          : [];

        setChartData(aggregatedData);
      } catch (err) {
        console.error("Error fetching chart data:", err);
        setError(err.message || "An unknown error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [isArn]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="p-2 relative">
      <DonutChart data={chartData} />
    </div>
  );
}

// import DonutChart from "../../../components/Charts/DonutChart";
// import { useEffect, useState } from "react";
// import { axInst, axInstBasic } from "../../../components/Service/Service";

// export default function VehicleInsuranceExpiring({ isArn }) {
//   const [chartData, setChartData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//   const fetchData = async () => {
//     if (!isArn) return; // don't call API until ARN is available

//     const basicAuth =
//       "Basic " +
//       btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);

//     try {
//       const response = await axInstBasic.post(
//         `${process.env.REACT_APP_API_URL}PermitType`,
//         { isArn },
//         // uncomment if needed:
//         // {
//         //   headers: {
//         //     Authorization: basicAuth,
//         //     "Content-Type": "application/json",
//         //   },
//         // }
//       );

//       const rawResponse = response.data;
//       const aggregatedData = Array.isArray(rawResponse.result?.buckets)
//         ? rawResponse.result.buckets.map((bucket) => ({
//             name: bucket.key,
//             value: bucket.doc_count,
//           }))
//         : [];
//       setChartData(aggregatedData);
//     } catch (err) {
//       console.error("Error fetching chart data:", err);
//       setError(err.message || "An unknown error occurred");
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchData();
// }, [isArn]); // ✅ re-run when ARN updates


//   if (loading) return <p>Loading...</p>;
//   if (error) return <p>Error: {error}</p>;

//   return (
//     <div className="p-2 relative">
//       <DonutChart data={chartData} />
//     </div>
//   );
// }
